import React, { Fragment, useState } from 'react';
import { DynamicContainer, Transition } from 'components';
import css from './accordion.scss';

export function Accordion(props) {
  const [ state, setState ] = useState({ 0: true });
  return props.children.map((item, index) =>
    <Fragment key={item.props.title}>
      { index > 0 && <div className={css.separator} /> }
      <h3 className={props.faq ? css.faqTitle : css.title} onClick={() => setState(({ ...state, [index]: !state[index] }))}>

        { props.faq
          ? <svg viewBox="0 0 100 100" className={css.icon}>
            <path className={[css.first, !state[index] && css.off].join(' ')} d="M17.625,47 L82.375,47 C83.8247475,47 85,48.3431458 85,50 C85,51.6568542 83.8247475,53 82.375,53 L17.625,53 C16.1752525,53 15,51.6568542 15,50 C15,48.3431458 16.1752525,47 17.625,47 Z" />
            <path className={[css.second, !state[index] && css.off].join(' ')} d="M17.625,47 L82.375,47 C83.8247475,47 85,48.3431458 85,50 C85,51.6568542 83.8247475,53 82.375,53 L17.625,53 C16.1752525,53 15,51.6568542 15,50 C15,48.3431458 16.1752525,47 17.625,47 Z" />
          </svg>
          : <svg viewBox="0 0 404.257 404.257" className={[css.chevron, state[index] && css.on].join(' ')}>
            <path d="M386.257 114.331L202.128 252.427 18 114.331l-18 24 202.128 151.596 202.129-151.596z" />
          </svg>
        }

        { item.props.title }
      </h3>
      <DynamicContainer>
        <Transition in={state[index]} mountOnEnter unmountOnExit classNames={css.locals} onExited={() => setState(refresh)}>
          <div className={css.item}>
            { item }
          </div>
        </Transition>
      </DynamicContainer>
    </Fragment>
  );
}

function refresh(state) {
  return { ...state }
}
